import React from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../hooks/use-language";
import { useLanguageSelection } from "../../../hooks/use-language-selection";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";
import { buildMakeMakeComercialUrlByEnv } from "../../../util/host-utilities";

export const FooterActionPanel = () => {
	const lang = useLanguage();
	const languageSelection = useLanguageSelection();
	const footerTexts = useTranslationsById({ mainSectionName: "footer", language: lang });
	const nextLang = lang === "es" ? "en" : "es";
	const languageLabel =
		lang === "es"
			? footerTexts.getText({ id: "actions.language.es", defaultText: "Español" })
			: footerTexts.getText({ id: "actions.language.en", defaultText: "English" });

	return (
		<div className="footer-action-panel">
			<button
				className="buttonv2 button-secondary focusable-red footer-action-button footer-language-button"
				type="button"
				onClick={() => languageSelection.setLanguage({ lang: nextLang })}
				aria-label={`Cambiar idioma a ${nextLang === "es" ? "Español" : "English"}`}
			>
				<span>{languageLabel}</span>
				<Icon icon="mdi:translate" width={22} />
			</button>
			<a
				href={buildMakeMakeComercialUrlByEnv({ path: "/contacto", hash: "demo" })}
				target="_self"
				// rel="noopener noreferrer"
				className="buttonv2 button-primary focusable-red footer-action-button"
			>
				{footerTexts.getText({ id: "actions.demo", defaultText: "Pide un demo" })}
			</a>
			<a
				href={buildMakeMakeComercialUrlByEnv({ path: "/contacto", hash: "cita" })}
				target="_self"
				// rel="noopener noreferrer"
				className="buttonv2 button-secondary focusable-red footer-action-button"
			>
				{footerTexts.getText({ id: "actions.contact", defaultText: "Contáctanos" })}
			</a>
			<Link
				to="/admin/login"
				className="buttonv2 button-primary focusable-red footer-action-button"
			>
				{footerTexts.getText({ id: "actions.admin", defaultText: "Admin" })}
			</Link>
		</div>
	);
};
